// Stock footage cities — landmark images via Wikipedia/Wikimedia (freely licensed)
export const STOCK_CITIES = [
  { name: "Lucknow", landmark: "Rumi Darwaza", img: "/assets/cities/lucknow.jpg" },
  { name: "Kanpur", landmark: "JK Temple", img: "/assets/cities/kanpur.jpg" },
  { name: "Prayagraj", landmark: "Triveni Sangam", img: "/assets/cities/prayagraj.jpg" },
  { name: "Varanasi", landmark: "Ganges Ghats", img: "/assets/cities/varanasi.jpg" },
  { name: "Jaipur", landmark: "Hawa Mahal", img: "/assets/cities/jaipur.jpg" },
  { name: "Kashmir", landmark: "Dal Lake", img: "/assets/cities/kashmir.jpg" },
];
